// src/pages/faq/index.js
import Faq from './Faq'
import NuevaPregunta from './NuevaPregunta'
import VerPregunta from './VerPregunta'
import EditarPregunta from './EditarPregunta'
import EliminarPregunta from './EliminarPregunta'

export {
	Faq,
	NuevaPregunta,
	VerPregunta,
	EditarPregunta,
	EliminarPregunta
}

export default Faq